import type { IconProps } from './types';

export const XCloseIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 20, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
      ref={ref}
    >
      <path d="M21.375 2.625L2.625 21.375" stroke={color} strokeWidth="1.5" />
      <path d="M2.625 2.625L21.375 21.375" stroke={color} strokeWidth="1.5" />
    </svg>
  );
};
